import React, { createContext, useContext, useState } from "react";
import type * as mapboxgl from "mapbox-gl";

interface MapContextType {
  map: mapboxgl.Map | null;
  setMap: (map: mapboxgl.Map | null) => void;
  /** What the pointer is over on the map; "" when nothing. */
  hoverText: string;
  setHoverText: (text: string) => void;
}

const MapContext = createContext<MapContextType>({
  map: null,
  setMap: () => {},
  hoverText: "",
  setHoverText: () => {},
});

export const useMap = () => useContext(MapContext);

export const MapProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [map, setMap] = useState<mapboxgl.Map | null>(null);
  const [hoverText, setHoverText] = useState("");

  return (
    <MapContext.Provider value={{ map, setMap, hoverText, setHoverText }}>
      {children}
    </MapContext.Provider>
  );
};

export default MapContext;
